import { abilitiesPlugin } from '@casl/vue';
import ability from './ability';

export default {
  install(app) {
    app.use(abilitiesPlugin, ability, {
      useGlobalProperties: true,
    });
  },
};
